import React, { useState, useEffect } from "react";

import { IUserResponse, IUserDTO } from "app/api/types";
import "./styles.scss";

interface IProps {
  user: IUserResponse;
  isActive: boolean;
  onSubmit: (data: IUserDTO) => void;
}

const EditUserForm: React.FC<IProps> = props => {
  const [name, setName] = useState(props.user.name);
  const [email, setEmail] = useState(props.user.email);
  const [password, setPassword] = useState("");

  const [errorStyle, setErrorStyle] = useState({
    email: "",
    name: "",
    password: ""
  });

  const handleChange = (e: any) => {
    e.target.name === "name" && setName(e.target.value);
    e.target.name === "email" && setEmail(e.target.value);
    e.target.name === "password" && setPassword(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (name.length > 1 && password.length > 1 && email.length > 1)
      props.onSubmit({
        id: props.user.id!,
        email,
        password,
        name
      });
  };

  useEffect(() => {
    setErrorStyle({
      email: email && email.length > 1 ? "" : "edit-phrase__input_error",
      name: name && name.length > 1 ? "" : "edit-phrase__input_error",
      password:
        password && password.length > 1 ? "" : "edit-phrase__input_error"
    });
  }, [email, name, password]);

  return (
    <form
      className={`edit-phrase__form ${props.isActive ? "active" : ""}`}
      onSubmit={handleSubmit}
    >
      <label htmlFor="name" className="edit-phrase__label">
        имя
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.name}`}
        type="text"
        placeholder={name}
        name="name"
        value={name}
        onChange={handleChange}
        autoComplete="off"
      />

      <label htmlFor="email" className="edit-phrase__label">
        email
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.email}`}
        type="text"
        placeholder={email}
        name="email"
        value={email}
        onChange={handleChange}
        autoComplete="off"
      />

      <label htmlFor="password" className="edit-phrase__label">
        пароль
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.password}`}
        type="text"
        placeholder={password}
        name="password"
        value={password}
        onChange={handleChange}
        autoComplete="off"
      />

      <button className="edit-phrase__submit">cохранить</button>
    </form>
  );
};

export default EditUserForm;
